import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-44a6f0c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-container" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "compare-container" }
const _hoisted_4 = { class: "compare-header" }
const _hoisted_5 = { class: "select-revisions" }
const _hoisted_6 = { class: "d-flex" }

import { ref } from "vue";
import BaseDialog from "@/components/base/dialogs/BaseDialog.vue";
import { AssetManagementPlan, AssetManagementPlanMaster } from "@/classes";
import { sections } from "../sections";
import DiffGeneral from "./DiffGeneral.vue";
import DiffIntroduction from "./DiffIntroduction.vue";
import DiffRACI from "./DiffRACI.vue";
import DiffScopeBoundaryLimits from "./DiffScopeBoundaryLimits.vue";
import DiffAssetInformation from "./DiffAssetInformation.vue";
import DiffAssetManagementPlan from "./DiffAssetManagementPlan.vue";
import DiffServiceLevelKPIs from "./DiffServiceLevelKPIs.vue";
import DiffLifeCycleCostModelling from "./DiffLifeCycleCostModelling.vue";
import DiffImprovementActions from "./DiffImprovementActions.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareRevisionsDialog',
  props: {
    master: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const dialog = ref(false);
const currRevision = ref(new AssetManagementPlan());
const prevRevision = ref<AssetManagementPlan | null>(null);

const tabKey = ref<string>("general");

const open = async (revision: AssetManagementPlan) => {
  dialog.value = true;
  tabKey.value = "general";
  await getCurrRevision(revision);
  const index = props.master.asset_management_plans.findIndex(
    (r) => r.id === revision.id,
  );
  if (index >= 0 && index < props.master.asset_management_plans.length - 1) {
    await getPrevRevision(props.master.asset_management_plans[index + 1]);
  } else {
    prevRevision.value = null;
  }
};

const loadingPrev = ref(false);
const loadingCurr = ref(false);

const getPrevRevision = async (revision: AssetManagementPlan | null) => {
  loadingPrev.value = true;
  if (revision) {
    prevRevision.value = await AssetManagementPlan.get(revision.id);
    prevRevision.value.fixRelationships();
  } else {
    prevRevision.value = null;
  }
  loadingPrev.value = false;
};

const getCurrRevision = async (revision: AssetManagementPlan | null) => {
  if (!revision) return;
  loadingCurr.value = true;
  currRevision.value = await AssetManagementPlan.get(revision.id);
  currRevision.value.fixRelationships();
  loadingCurr.value = false;
};

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(BaseDialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog).value = $event)),
    title: "Compare Revisions",
    "max-width": "1600",
    "content-class": "pa-0 d-flex overflow-hidden"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_list_item, {
            title: "Asset Management Plan",
            subtitle: _ctx.master.name ?? ''
          }, null, 8, ["subtitle"]),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_list, {
            modelValue: tabKey.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tabKey).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sections), (section) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: section.key,
                  link: "",
                  title: section.title,
                  active: section.key === tabKey.value,
                  density: "compact",
                  onClick: ($event: any) => (tabKey.value = section.key)
                }, null, 8, ["title", "active", "onClick"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_v_divider, { vertical: "" }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_autocomplete, {
                class: "px-2",
                style: {"width":"50%"},
                "model-value": prevRevision.value,
                label: "Previous Revision",
                items: _ctx.master.asset_management_plans,
                "item-value": "id",
                "item-title": "revision",
                "return-object": "",
                density: "compact",
                "hide-details": "",
                loading: loadingPrev.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (getPrevRevision($event)))
              }, null, 8, ["model-value", "items", "loading"]),
              _createVNode(_component_v_autocomplete, {
                class: "px-2",
                style: {"width":"50%"},
                "model-value": currRevision.value,
                label: "Current Revision",
                items: _ctx.master.asset_management_plans,
                "item-value": "id",
                "item-title": "revision",
                "return-object": "",
                density: "compact",
                "hide-details": "",
                loading: loadingCurr.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (getCurrRevision($event)))
              }, null, 8, ["model-value", "items", "loading"])
            ]),
            _createVNode(_component_v_divider)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (tabKey.value === 'general')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(DiffGeneral, { plan: prevRevision.value }, null, 8, ["plan"]),
                  _createVNode(DiffGeneral, {
                    plan: currRevision.value,
                    "diff-plan": prevRevision.value,
                    diff: ""
                  }, null, 8, ["plan", "diff-plan"])
                ], 64))
              : (tabKey.value === 'introduction')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(DiffIntroduction, { plan: prevRevision.value }, null, 8, ["plan"]),
                    _createVNode(DiffIntroduction, {
                      plan: currRevision.value,
                      "diff-plan": prevRevision.value,
                      diff: ""
                    }, null, 8, ["plan", "diff-plan"])
                  ], 64))
                : (tabKey.value === 'raci')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(DiffRACI, { plan: prevRevision.value }, null, 8, ["plan"]),
                      _createVNode(DiffRACI, {
                        plan: currRevision.value,
                        "diff-plan": prevRevision.value,
                        diff: ""
                      }, null, 8, ["plan", "diff-plan"])
                    ], 64))
                  : (tabKey.value === 'scope-boundary-limits')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createVNode(DiffScopeBoundaryLimits, { plan: prevRevision.value }, null, 8, ["plan"]),
                        _createVNode(DiffScopeBoundaryLimits, {
                          plan: currRevision.value,
                          "diff-plan": prevRevision.value,
                          diff: ""
                        }, null, 8, ["plan", "diff-plan"])
                      ], 64))
                    : (tabKey.value === 'asset-information')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createVNode(DiffAssetInformation, { plan: prevRevision.value }, null, 8, ["plan"]),
                          _createVNode(DiffAssetInformation, {
                            plan: currRevision.value,
                            "diff-plan": prevRevision.value,
                            diff: ""
                          }, null, 8, ["plan", "diff-plan"])
                        ], 64))
                      : (tabKey.value === 'asset-management-plan')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            _createVNode(DiffAssetManagementPlan, { plan: prevRevision.value }, null, 8, ["plan"]),
                            _createVNode(DiffAssetManagementPlan, {
                              plan: currRevision.value,
                              "diff-plan": prevRevision.value,
                              diff: ""
                            }, null, 8, ["plan", "diff-plan"])
                          ], 64))
                        : (tabKey.value === 'service-levels-kpis')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                              _createVNode(DiffServiceLevelKPIs, { plan: prevRevision.value }, null, 8, ["plan"]),
                              _createVNode(DiffServiceLevelKPIs, {
                                plan: currRevision.value,
                                "diff-plan": prevRevision.value,
                                diff: ""
                              }, null, 8, ["plan", "diff-plan"])
                            ], 64))
                          : (tabKey.value === 'life-cycle-cost-modelling')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                _createVNode(DiffLifeCycleCostModelling, { plan: prevRevision.value }, null, 8, ["plan"]),
                                _createVNode(DiffLifeCycleCostModelling, {
                                  plan: currRevision.value,
                                  "diff-plan": prevRevision.value,
                                  diff: ""
                                }, null, 8, ["plan", "diff-plan"])
                              ], 64))
                            : (tabKey.value === 'improvement-actions')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                  _createVNode(DiffImprovementActions, { plan: prevRevision.value }, null, 8, ["plan"]),
                                  _createVNode(DiffImprovementActions, {
                                    plan: currRevision.value,
                                    "diff-plan": prevRevision.value,
                                    diff: ""
                                  }, null, 8, ["plan", "diff-plan"])
                                ], 64))
                              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})